<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="250"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-power-standby</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Close the App?
      </v-card-title>
      <v-card-text>
        Are your sure you want to close the app?
        any unsaved changes made will be discarded.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="closeAction(true)"
        >
          Yes
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="closeAction(false)"
        >
          No
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'CloseDialog',
    data: () => {
      return {
        dialog: false,
      }
    },
    methods: {
      closeAction: function (close) {
        this.$emit('close-window', close)
        this.dialog = false
      },
    },
  }
</script>
